(function () {

  'use strict';

  angular.module('DeployAssistant')
    .controller('DeployAssistantController', function ($http, $rootScope, $routeParams, $scope, currentTenant) {

      $scope.tenant = currentTenant;
      $scope.selectedTool = 'INVITE_USERS';
      $scope.workstationCount = 0;

      $scope.$watch(function () {
        return $rootScope.currentUser;
      }, function () {
        if ($rootScope.currentUser) {
          $scope.me = $rootScope.currentUser;
        }
      });

      $scope.selectTool = function (tool) {
        $scope.selectedTool = tool;
        setContextHelp();
      };

      (function () {
        checkQueryParam();
        getWorkstationCount();
        setContextHelp();
      })();

      function checkQueryParam() {
        if ($routeParams.todo === 'add_user' && $scope.tenant.info.todoMap.ADD_USER) {
          $scope.tenant.removeToDoItem($scope.tenant.info.todoMap.ADD_USER);
        }
      }

      function getWorkstationCount() {
        const url = $scope.tenant.info._links['px:workstations'].href;
        const params = { page: 0, pageSize: 1, sort: 'NAME', direction: 'ASC' };
        $scope.working = true;
        $http.get(url, { params })
          .then(function (response) {
            $scope.workstationCount = response.data.page.totalElements;
            $scope.working = false;
          })
          .catch(function () {
            $scope.working = false;
          });
      }

      function setContextHelp() {
        switch ($scope.selectedTool) {
          case 'INVITE_USERS':
            $scope.helpCaption = 'HelpImplementationAssistantImplementation';
            break;
          case 'DEFINE_NETWORK':
            $scope.helpCaption = 'HelpImplementationAssistantDefineNetworks';
            break;
        }
      }

    });

})();
